import colors from './style/colors'

// Les 3 états de disponibilité d'un produit, dans l'ordre d'affichage
export const STOCK_STATUSES = ['available', 'waitlist', 'unavailable']

export const STOCK_META = {
  available: {
    label: 'Disponible',
    adminLabel: '✅ Dispo',
    badge: colors.vertOlive,
    dot: '#22c55e',
  },
  waitlist: {
    label: "Sur liste d'attente",
    adminLabel: "⏳ Liste d'attente",
    badge: '#c47f1d',
    dot: '#f59e0b',
  },
  unavailable: {
    label: 'Indisponible',
    adminLabel: '❌ Indispo',
    badge: '#c0392b',
    dot: '#e05a5a',
  },
}

// Tolère les lignes anciennes qui n'ont encore que le booléen `available`
export function stockStatusOf(product) {
  const s = product?.stock_status
  if (STOCK_META[s]) return s
  return product?.available === false ? 'unavailable' : 'available'
}

export const stockMeta = (product) => STOCK_META[stockStatusOf(product)]

// Commandable = demandable en devis (dispo ou liste d'attente)
export const isOrderable = (product) => stockStatusOf(product) !== 'unavailable'
